import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 3,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm" }
const _hoisted_20 = {
  key: 4,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = {
  key: 5,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_27 = { class: "control-label col-sm-6" }
const _hoisted_28 = { class: "col-sm" }
const _hoisted_29 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_30 = { class: "control-label col-sm-6" }
const _hoisted_31 = { class: "col-sm" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_34 = { class: "control-label col-sm-6" }
const _hoisted_35 = { class: "col-sm" }
const _hoisted_36 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_43 = { class: "control-label col-sm-6" }
const _hoisted_44 = { class: "col-sm" }
const _hoisted_45 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_46 = { class: "control-label col-sm-6" }
const _hoisted_47 = { class: "col-sm" }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_50 = { class: "control-label col-sm-6" }
const _hoisted_51 = { class: "col-sm" }
const _hoisted_52 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_53 = { class: "control-label col-sm-6" }
const _hoisted_54 = { class: "col-sm" }
const _hoisted_55 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_56 = { class: "control-label col-sm-6" }
const _hoisted_57 = { class: "col-sm" }
const _hoisted_58 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_59 = { class: "control-label col-sm-6" }
const _hoisted_60 = { class: "col-sm" }
const _hoisted_61 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_62 = { class: "control-label col-sm-6" }
const _hoisted_63 = { class: "col-sm" }
const _hoisted_64 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_65 = { class: "control-label col-sm-6" }
const _hoisted_66 = { class: "col-sm" }
const _hoisted_67 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_68 = { class: "control-label col-sm-6" }
const _hoisted_69 = { class: "col-sm" }
const _hoisted_70 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_71 = { class: "control-label col-sm-6" }
const _hoisted_72 = { class: "col-sm" }

import { ref, watch , inject} from 'vue';
import { usePreventivo } from '../../composable/usePreventivo'
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import FormSocietarioHelper from "../../pages/preventivi/json/societario/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareDonazioniRisoluzioniAttiCostitutivi',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione','update:validate-to'],
  setup(__props, { emit: __emit }) {

const $AxiosClient = inject('$AxiosClient');
const {
  categoriaImmobiliare,
  categoriaSocietario,
  formatterSomma
} = usePreventivo();
const props = __props;
const testoInfoCompilazione = ref([]);
const { regimeFiscale } = inject('regimeFiscale')
const emits = __emit;
let validazione;
const validazioneEquoCompenso = ref();
const calcoloValoreDaRendita = ref(false);
let indexHelperClosing = '';
switch (props.formName) {
  case 'donazioniBeniImmobili':
    validazione = categoriaImmobiliare['sottocategoriaDonazioniRisoluzioniAttiCostitutivi']['donazioniBeniImmobili'];
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaDonazioniRisoluzioniAttiCostitutivi']['donazioniBeniImmobili'];
    validazione.tipo_preventivo.value = 'immobiliare/donazioni_risoluzioni/' + props.tipoPreventivo.data.url
    indexHelperClosing = {
      calcolo: FormImmobiliareHelper.sottocategoriaDonazioniRisoluzioniAttiCostitutivi[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    };
    testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaDonazioniRisoluzioniAttiCostitutivi[props.formName];
    break
  case 'donazioniDenaroAltriTitoliAzioniObbligazioni':
    validazione = categoriaSocietario['sottocategoriaDonazioniRisoluzioniAttiCostitutivi']['donazioniDenaroAltriTitoliAzioniObbligazioni'];
    validazioneEquoCompenso.value = categoriaSocietario['sottocategoriaDonazioniRisoluzioniAttiCostitutivi']['donazioniDenaroAltriTitoliAzioniObbligazioni'];
    validazione.tipo_preventivo.value = 'societario/donazioni_risoluzioni/' + props.tipoPreventivo.data.url
    indexHelperClosing = {
      calcolo: FormSocietarioHelper.sottocategoriaDonazioniRisoluzioniAttiCostitutivi[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaDonazioniRisoluzioniAttiCostitutivi[props.formName];
    break
  case 'donazioniPartecipazioniSocialiAziende':
    validazione = categoriaSocietario['sottocategoriaDonazioniRisoluzioniAttiCostitutivi']['donazioniPartecipazioniSocialiAziende'];
    validazioneEquoCompenso.value = categoriaSocietario['sottocategoriaDonazioniRisoluzioniAttiCostitutivi']['donazioniPartecipazioniSocialiAziende'];
    validazione.tipo_preventivo.value = 'societario/donazioni_risoluzioni/' + props.tipoPreventivo.data.url
    indexHelperClosing = {
      calcolo: FormSocietarioHelper.sottocategoriaDonazioniRisoluzioniAttiCostitutivi[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    testoInfoCompilazione.value =  FormSocietarioHelper.sottocategoriaDonazioniRisoluzioniAttiCostitutivi[props.formName];
    break
}
watch(validazione, () => {
  emits('changeDatiPreventivo');
}, { deep: true })
function tipologia (event) {
  if (event.target.value === 'valore_suggerito_da_rendita_catastale'){
    validazione.rendita_catastale_prima_casa.value = '0'
   validazione.tipologia_immobile.required = false;
    calcoloValoreDaRendita.value = true;
    validazione.abilitare_equo_compenso.value = 0;
    validazione.tipologia_tabella_calcolo.value = '';
  } else {
    validazione.abilitare_equo_compenso.value = 0;
    validazione.rendita_catastale_prima_casa.value = '';
    validazione.tipologia_immobile.value = '';
    validazione.rendita_catastale_seconda_casa.value = '0';
    validazione.valore_prima_casa.value = '';
    validazione.valore_altri_beni.value = '';
    calcoloValoreDaRendita.value = false;
    validazione.tipologia_tabella_calcolo.value = '';
  }
}
function updateTipologiaImmobile (event) {
  let valore;
  if (event.target.name === 'rendita_catastale_seconda_casa') {
    valore = formatterSomma(event.target.value.replace('€', ''))
    if (valore > 0) {
      validazione.tipologia_immobile.required = true
    } else {
      validazione.tipologia_immobile.required = false
      validazione.tipologia_immobile.value = ''
    }
  }
}
async function calcolaValore(event){
  if (event.target.name === 'rendita_catastale_seconda_casa'){
    updateTipologiaImmobile(event)
  }
  if(validazione.rendita_catastale_prima_casa.value === ''){
    validazione.rendita_catastale_prima_casa.value = '0'
  }
  if(validazione.rendita_catastale_seconda_casa.value === ''){
    validazione.rendita_catastale_seconda_casa.value = '0'
  }
  if (validazione.tipologia_immobile.value === '') {
      return;
  }
    let valoreCalcolato = await $AxiosClient.post('Utilita', 'calcolo_valore_da_rendita_catastale',{
      'rendita_catastale_prima_casa': validazione.rendita_catastale_prima_casa.value,
      'rendita_catastale_seconda_casa': validazione.rendita_catastale_seconda_casa.value,
      'tipologia_immobile': validazione.tipologia_immobile.value,
      'tipo_utilita': 'immobiliare/calcolo_valore_da_rendita_catastale'
    },{messages:false});

    if (valoreCalcolato.esito === 'ok') {
      validazione.valore_prima_casa.value = valoreCalcolato.valore_prima_casa;
      validazione.valore_altri_beni.value = valoreCalcolato.valore_altri_beni;
    }
}
emits('infoCompilazione',  testoInfoCompilazione);

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'donazioniBeniImmobili')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipologia.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "tipologia",
                options: [
            {name: 'Valore suggerito da rendita catastale', value: 'valore_suggerito_da_rendita_catastale'},
            {name: 'Valore libero', value: 'valore_libero'}],
                onChange: _cache[0] || (_cache[0] = $event => (tipologia($event))),
                isSelected: _unref(validazione).tipologia.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).tipologia,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).tipologia) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(validazione).tipologia.value === 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_prima_casa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_prima_casa.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_input_text, {
                    id: "rendita_catastale_prima_casa",
                    name: "rendita_catastale_prima_casa",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    onChange: _cache[2] || (_cache[2] = $event => (calcoloValoreDaRendita.value ? calcolaValore($event): '')),
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).rendita_catastale_prima_casa,
                    "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).rendita_catastale_prima_casa) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipologia.value === 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(validazione).rendita_catastale_seconda_casa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.rendita_catastale_seconda_casa.ref]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_input_text, {
                    id: "rendita_catastale_seconda_casa",
                    name: "rendita_catastale_seconda_casa",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    onChange: _cache[4] || (_cache[4] = $event => (calcoloValoreDaRendita.value ? calcolaValore($event): '')),
                    "validate-to": _unref(validazione).rendita_catastale_seconda_casa,
                    "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).rendita_catastale_seconda_casa) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipologia.value === 'valore_libero')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_prima_casa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_prima_casa.ref]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_prima_casa",
                    name: "valore_prima_casa",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_prima_casa,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).valore_prima_casa) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipologia.value === 'valore_libero')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore_altri_beni.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_altri_beni.ref]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_input_text, {
                    id: "valore_altri_beni",
                    name: "valore_altri_beni",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore_altri_beni,
                    "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).valore_altri_beni) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
              _createTextVNode(_toDisplayString(_unref(validazione).categoria.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.categoria.ref]
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_base_select, {
                name: "categoria",
                options: [{name: 'A favore del coniuge e di parenti in linea retta', value: 'a_favore_del_coniuge_e_di_parenti_in_linea_retta'},
            {name: 'A favore di Fratelli e Sorelle (non di loro rappresentanti)', value: 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti'},
            {name: 'A favore di altri parenti fino al 4° Affini in linea retta - in linea collaterale fino al 3° - (genero nuora)', value: 'a_favore_di_altri_parenti_fino_al_quarto_grado_affini_in_linea_retta'},
            {name: ' A favore di tutti gli altri soggetti', value: 'a_favore_di_tutti_gli_altri_soggetti'}],
                isSelected: _unref(validazione).categoria.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).categoria,
                "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).categoria) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(validazione).tipologia.value === 'valore_suggerito_da_rendita_catastale' && _unref(validazione).rendita_catastale_seconda_casa.value !== '' && _unref(validazione).rendita_catastale_seconda_casa.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipologia_immobile.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipologia_immobile.ref]
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_base_select, {
                    name: "tipologia_immobile",
                    options: [{name: 'Tutti i fabb. abitativi e pertinenze (A,C escluse A/10 e C/1)', value: 'cat_a_c'},
            {name: 'Cat. B (Immobili destinati a servizi)', value: 'cat_b'},
            {name: 'Cat. D + A/10 (Uffici e studi privati / Destinazione speciale)', value: 'cat_d_a10'},
            {name: 'Cat. E + C/1 (Negozi / Destinazione particolare)', value: 'cat_e_c1'},
            {name: 'Cat. T (Terreni agricoli)', value: 'cat_t'}],
                    onChange: _cache[9] || (_cache[9] = $event => (calcoloValoreDaRendita.value ? calcolaValore($event): '')),
                    isSelected: _unref(validazione).tipologia_immobile.value !== '',
                    state: __props.readonly === true ? 'disable' : '',
                    validateTo: _unref(validazione).tipologia_immobile,
                    "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).tipologia_immobile) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).categoria.value === 'a_favore_del_coniuge_e_di_parenti_in_linea_retta' || _unref(validazione).categoria.value === 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_unref(validazione).donazioni_precedenti.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.donazioni_precedenti.ref]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_base_input_text, {
                    id: "donazioni_precedenti",
                    name: "donazioni_precedenti",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).donazioni_precedenti,
                    "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).donazioni_precedenti) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_27, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_base_input_text, {
                id: "numero_conservatorie",
                name: "numero_conservatorie",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero conservatorie",
                disabled: __props.readonly,
                "validate-to": _unref(validazione).numero_conservatorie,
                "onUpdate:validateTo": _cache[12] || (_cache[12] = $event => ((_unref(validazione).numero_conservatorie) = $event))
              }, null, 8 /* PROPS */, ["disabled", "validate-to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(validazione).portatore_handicap.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.portatore_handicap.ref]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_base_input_checkbox, {
                class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                name: "portatore_handicap",
                label: "Sì",
                "validate-to": _unref(validazione).portatore_handicap,
                "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).portatore_handicap) = $event))
              }, null, 8 /* PROPS */, ["class", "validate-to"])
            ])
          ]),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          (_unref(validazione).tipologia.value === 'valore_suggerito_da_rendita_catastale')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 6,
                "input-riferimento-calcolo": ['rendita_catastale_prima_casa','rendita_catastale_seconda_casa'],
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true),
          (_unref(validazione).tipologia.value === 'valore_libero')
            ? (_openBlock(), _createBlock(CalcoloEquoCompenso, {
                key: 7,
                "input-riferimento-calcolo": ['valore_prima_casa','valore_altri_beni'],
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]))
            : _createCommentVNode("v-if", true)
        ]))
      : (__props.formName === 'donazioniDenaroAltriTitoliAzioniObbligazioni')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createTextVNode(_toDisplayString(_unref(validazione).valore.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore.ref]
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_base_input_text, {
                  id: "valore",
                  name: "valore",
                  class: "placeholder-right",
                  placeholder: "0,00",
                  disabled: __props.readonly,
                  "validate-to": _unref(validazione).valore,
                  "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).valore) = $event))
                }, null, 8 /* PROPS */, ["disabled", "validate-to"])
              ])
            ]),
            (_unref(validazione).categoria.value === 'a_favore_del_coniuge_e_di_parenti_in_linea_retta' || _unref(validazione).categoria.value === 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_unref(validazione).donazioni_precedenti.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.donazioni_precedenti.ref]
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_base_input_text, {
                      id: "donazioni_precedenti",
                      name: "donazioni_precedenti",
                      class: "placeholder-right",
                      placeholder: "0,00",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).donazioni_precedenti,
                      "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).donazioni_precedenti) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_39, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                _createTextVNode(_toDisplayString(_unref(validazione).categoria.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.categoria.ref]
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_base_select, {
                  name: "categoria",
                  options: [{name: 'A favore del coniuge e di parenti in linea retta', value: 'a_favore_del_coniuge_e_di_parenti_in_linea_retta'},
            {name: 'A favore di Fratelli e Sorelle (non di loro rappresentanti)', value: 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti'},
            {name: 'A favore di altri parenti fino al 4° Affini in linea retta - in linea collaterale fino al 3° - (genero nuora)', value: 'a_favore_di_altri_parenti_fino_al_quarto_grado_affini_in_linea_retta'},
            {name: ' A favore di tutti gli altri soggetti', value: 'a_favore_di_tutti_gli_altri_soggetti'}],
                  isSelected: _unref(validazione).categoria.value !== '',
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).categoria,
                  "onUpdate:validateTo": _cache[16] || (_cache[16] = $event => ((_unref(validazione).categoria) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_43, [
                _createTextVNode(_toDisplayString(_unref(validazione).portatore_handicap.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.portatore_handicap.ref]
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_base_input_checkbox, {
                  class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                  name: "portatore_handicap",
                  label: "Sì",
                  "validate-to": _unref(validazione).portatore_handicap,
                  "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).portatore_handicap) = $event))
                }, null, 8 /* PROPS */, ["class", "validate-to"])
              ])
            ]),
            (_unref(regimeFiscale) === 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_46, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[18] || (_cache[18] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "valore",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'donazioniPartecipazioniSocialiAziende')
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_50, [
                  _createTextVNode(_toDisplayString(_unref(validazione).oggetto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.oggetto.ref]
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_base_select, {
                    name: "oggetto",
                    options: [{name: 'Donazione di Azienda', value: 'donazione_azienda'},
            {name: 'Donazione di partecipazione', value: 'donazione_partecipazione'}],
                    isSelected: _unref(validazione).oggetto.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).oggetto,
                    "onUpdate:validateTo": _cache[19] || (_cache[19] = $event => ((_unref(validazione).oggetto) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              (_unref(validazione).oggetto.value === 'donazione_partecipazione')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_53, [
                      _createTextVNode(_toDisplayString(_unref(validazione).comunicazione_socio_unico.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.comunicazione_socio_unico.ref]
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                        name: "comunicazione_socio_unico",
                        label: "Sì, comunicazione socio unico",
                        "validate-to": _unref(validazione).comunicazione_socio_unico,
                        "onUpdate:validateTo": _cache[20] || (_cache[20] = $event => ((_unref(validazione).comunicazione_socio_unico) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_55, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_56, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore.ref]
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_base_input_text, {
                    id: "valore",
                    name: "valore",
                    class: "placeholder-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore,
                    "onUpdate:validateTo": _cache[21] || (_cache[21] = $event => ((_unref(validazione).valore) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_59, [
                  _createTextVNode(_toDisplayString(_unref(validazione).tipo_societa.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_societa.ref]
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_base_select, {
                    name: "tipo_societa",
                    options: [{name: 'Ditte Individuali', value: 'ditte_individuali'},
            {name: 'Società di persone', value: 'societa_di_persone'},{name: 'Società di capitale', value: 'societa_di_capitale'}],
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).tipo_societa,
                    "onUpdate:validateTo": _cache[22] || (_cache[22] = $event => ((_unref(validazione).tipo_societa) = $event))
                  }, null, 8 /* PROPS */, ["state", "validateTo"])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_62, [
                  _createTextVNode(_toDisplayString(_unref(validazione).categoria.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.categoria.ref]
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_base_select, {
                    name: "categoria",
                    options: [{name: 'A favore del coniuge e di parenti in linea retta', value: 'a_favore_del_coniuge_e_di_parenti_in_linea_retta'},
            {name: 'A favore di Fratelli e Sorelle (non di loro rappresentanti)', value: 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti'},
            {name: 'A favore di altri parenti fino al 4° Affini in linea retta - in linea collaterale fino al 3° - (genero nuora)', value: 'a_favore_di_altri_parenti_fino_al_quarto_grado_affini_in_linea_retta'},
            {name: ' A favore di tutti gli altri soggetti', value: 'a_favore_di_tutti_gli_altri_soggetti'}],
                    isSelected: _unref(validazione).categoria.value !== '',
                    state: __props.readonly === true ?'disable':'',
                    validateTo: _unref(validazione).categoria,
                    "onUpdate:validateTo": _cache[23] || (_cache[23] = $event => ((_unref(validazione).categoria) = $event))
                  }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                ])
              ]),
              (_unref(validazione).categoria.value === 'a_favore_del_coniuge_e_di_parenti_in_linea_retta' || _unref(validazione).categoria.value === 'a_favore_di_fratelli_e_sorelle_non_di_loro_rappresentanti')
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_65, [
                      _createTextVNode(_toDisplayString(_unref(validazione).donazioni_precedenti.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.donazioni_precedenti.ref]
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(_component_base_input_text, {
                        id: "donazioni_precedenti",
                        name: "donazioni_precedenti",
                        class: "placeholder-right",
                        placeholder: "0,00",
                        disabled: __props.readonly,
                        "validate-to": _unref(validazione).donazioni_precedenti,
                        "onUpdate:validateTo": _cache[24] || (_cache[24] = $event => ((_unref(validazione).donazioni_precedenti) = $event))
                      }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_67, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_68, [
                  _createTextVNode(_toDisplayString(_unref(validazione).portatore_handicap.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.portatore_handicap.ref]
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "portatore_handicap",
                    label: "Sì",
                    "validate-to": _unref(validazione).portatore_handicap,
                    "onUpdate:validateTo": _cache[25] || (_cache[25] = $event => ((_unref(validazione).portatore_handicap) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]),
              (_unref(regimeFiscale) === 'ordinario')
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_71, [
                      _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                        name: "ritenuta_acconto",
                        label: "Si, applicabile",
                        "validate-to": _unref(validazione).ritenuta_acconto,
                        "onUpdate:validateTo": _cache[26] || (_cache[26] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                      }, null, 8 /* PROPS */, ["class", "validate-to"])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "valore",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}